module.exports = "/parking-permit/fonts/vendor/@mdi/materialdesignicons-webfont.woff?b4917be25082eb793b5363f2fdb5f282";